import type { AttendanceStatus } from '../types/hrmsAttendanceLeave.types'

interface AttendanceStatusPillProps {
  status: AttendanceStatus
  lateMinutes?: number
}

export function AttendanceStatusPill({ status, lateMinutes }: AttendanceStatusPillProps) {
  const norm = String(status || '').toUpperCase().replace(/[\s-]/g, '_')
  switch (norm) {
    case 'PRESENT':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700 border border-emerald-200">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
          Present
        </span>
      )
    case 'ON_LEAVE':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-orange-50 px-2.5 py-1 text-xs font-semibold text-orange-700 border border-orange-200">
          <span className="h-1.5 w-1.5 rounded-full bg-orange-500" />
          On Leave
        </span>
      )
    case 'LATE':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700 border border-amber-200">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
          Late {lateMinutes ? `(${lateMinutes} min)` : ''}
        </span>
      )
    case 'HALF_DAY':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-indigo-50 px-2.5 py-1 text-xs font-semibold text-indigo-700 border border-indigo-200">
          <span className="h-1.5 w-1.5 rounded-full bg-indigo-500" />
          Half Day
        </span>
      )
    case 'ABSENT':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700 border border-red-200">
          <span className="h-1.5 w-1.5 rounded-full bg-red-500" />
          Absent
        </span>
      )
    default:
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-50 px-2.5 py-1 text-xs font-semibold text-slate-700 border border-slate-200">
          <span className="h-1.5 w-1.5 rounded-full bg-slate-400" />
          {status}
        </span>
      )
  }
}
